export const options2 = [



    {
        "value": "浙江省",
        "label": "浙江省",
        "children": [{
                "value": "湖州市",
                "label": "湖州市",
                "children": [{
                        "value": "吴兴区",
                        "label": "吴兴区",
                        "children": [{
                                "value": "织里镇",
                                "label": "织里镇"
                            },
                            {
                                "value": "八里店镇",
                                "label": "八里店镇"
                            },
                            {
                                "value": "龙泉街道",
                                "label": "龙泉街道"
                            },
                            {
                                "value": "湖东街道",
                                "label": "湖东街道"
                            },
                            {
                                "value": "月河街道",
                                "label": "月河街道"
                            },
                            {
                                "value": "埭溪镇",
                                "label": "埭溪镇"
                            },
                            {
                                "value": "朝阳街道",
                                "label": "朝阳街道"
                            },
                            {
                                "value": "东林镇",
                                "label": "东林镇"
                            },
                            {
                                "value": "飞英街道",
                                "label": "飞英街道"
                            },
                            {
                                "value": "环渚街道",
                                "label": "环渚街道"
                            },
                            {
                                "value": "爱山街道",
                                "label": "爱山街道"
                            },
                            {
                                "value": "道场乡",
                                "label": "道场乡"
                            },
                            {
                                "value": "妙西镇",
                                "label": "妙西镇"
                            }
                        ],
                    }, {
                        "value": "南浔区",
                        "label": "南浔区",
                        "children": [{
                                "value": "南浔镇",
                                "label": "南浔镇"
                            },
                            {
                                "value": "练市镇",
                                "label": "练市镇"
                            },
                            {
                                "value": "双林镇",
                                "label": "双林镇"
                            },
                            {
                                "value": "菱湖镇",
                                "label": "菱湖镇"
                            },
                            {
                                "value": "和孚镇",
                                "label": "和孚镇"
                            },
                            {
                                "value": "旧馆镇",
                                "label": "旧馆镇"
                            },
                            {
                                "value": "善琏镇",
                                "label": "善琏镇"
                            },
                            {
                                "value": "千金镇",
                                "label": "千金镇"
                            },
                            {
                                "value": "石淙镇",
                                "label": "石淙镇"
                            }
                        ],
                    },


                    {
                        "value": "南太湖新区",
                        "label": "南太湖新区",
                        "children": [{
                                "value": "杨家埠街道",
                                "label": "杨家埠街道"
                            },
                            {
                                "value": "仁皇山街道",
                                "label": "仁皇山街道"
                            },
                            {
                                "value": "康山街道",
                                "label": "康山街道"
                            },
                            {
                                "value": "凤凰街道",
                                "label": "凤凰街道"
                            },
                            {
                                "value": "滨湖街道",
                                "label": "滨湖街道"
                            },
                            {
                                "value": "龙溪街道",
                                "label": "龙溪街道"
                            }

                        ],
                    }, {
                        "value": "德清县",
                        "label": "德清县"

                            ,
                        "children": [{
                                "value": "武康街道",
                                "label": "武康街道"
                            },
                            {
                                "value": "新市镇",
                                "label": "新市镇"
                            },
                            {
                                "value": "阜溪街道",
                                "label": "阜溪街道"
                            },
                            {
                                "value": "舞阳街道",
                                "label": "舞阳街道"
                            },
                            {
                                "value": "雷甸镇",
                                "label": "雷甸镇"
                            },
                            {
                                "value": "乾元镇",
                                "label": "乾元镇"
                            },
                            {
                                "value": "钟管镇",
                                "label": "钟管镇"
                            },
                            {
                                "value": "禹越镇",
                                "label": "禹越镇"
                            },
                            {
                                "value": "新安镇",
                                "label": "新安镇"
                            },
                            {
                                "value": "康乾街道",
                                "label": "康乾街道"
                            },
                            {
                                "value": "莫干山镇",
                                "label": "莫干山镇"
                            }

                            ,
                            {
                                "value": "下渚湖街道",
                                "label": "下渚湖街道"
                            },
                            {
                                "value": "洛舍镇",
                                "label": "洛舍镇"
                            }

                        ],
                    }, {
                        "value": "长兴县",
                        "label": "长兴县",
                        "children": [{
                                "value": "雉城街道",
                                "label": "雉城街道"
                            },
                            {
                                "value": "龙山街道",
                                "label": "龙山街道"
                            },
                            {
                                "value": "太湖街道",
                                "label": "太湖街道"
                            },
                            {
                                "value": "泗安镇",
                                "label": "泗安镇"
                            },
                            {
                                "value": "和平镇",
                                "label": "和平镇"
                            },
                            {
                                "value": "煤山镇",
                                "label": "煤山镇"
                            },
                            {
                                "value": "洪桥镇",
                                "label": "洪桥镇"
                            },
                            {
                                "value": "林城镇",
                                "label": "林城镇"
                            },
                            {
                                "value": "画溪街道",
                                "label": "画溪街道"
                            },
                            {
                                "value": "夹浦镇",
                                "label": "夹浦镇"
                            },
                            {
                                "value": "虹星桥镇",
                                "label": "虹星桥镇"
                            }

                            ,
                            {
                                "value": "李家巷镇",
                                "label": "李家巷镇"
                            },
                            {
                                "value": "小浦镇",
                                "label": "小浦镇"
                            },
                            {
                                "value": "吕山乡",
                                "label": "吕山乡"
                            },
                            {
                                "value": "水口乡",
                                "label": "水口乡"
                            }

                        ],
                    }, {
                        "value": "安吉县",
                        "label": "安吉县"


                            ,
                        "children": [{
                                "value": "昌硕街道",
                                "label": "昌硕街道"
                            },
                            {
                                "value": "递铺街道",
                                "label": "递铺街道"
                            },
                            {
                                "value": "梅溪镇",
                                "label": "梅溪镇"
                            },
                            {
                                "value": "天子湖镇",
                                "label": "天子湖镇"
                            },
                            {
                                "value": "孝丰镇",
                                "label": "孝丰镇"
                            },
                            {
                                "value": "灵峰街道",
                                "label": "灵峰街道"
                            },
                            {
                                "value": "杭垓镇",
                                "label": "杭垓镇"
                            },
                            {
                                "value": "天荒坪镇",
                                "label": "天荒坪镇"
                            },
                            {
                                "value": "孝源街道",
                                "label": "孝源街道"
                            },
                            {
                                "value": "报福镇",
                                "label": "报福镇"
                            },
                            {
                                "value": "上墅乡",
                                "label": "上墅乡"
                            }

                            ,
                            {
                                "value": "章村镇",
                                "label": "章村镇"
                            },
                            {
                                "value": "溪龙乡",
                                "label": "溪龙乡"
                            },
                            {
                                "value": "鄣吴镇",
                                "label": "鄣吴镇"
                            },
                            {
                                "value": "山川乡",
                                "label": "山川乡"
                            }

                        ],
                    }
                ]
            }


        ]
    }
]